<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import KubeForm from '@/components/kube/KubeForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        name: '',
        number: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.kube.store')"
        :query-key="[QueryKey.KUBE]"
        title="kube.create_kube"
        button-text="kube.create_kube"
    >
        <KubeForm :form="form" />
    </DialogForm>
</template>
